import * as types from '../actions/actionTypes';
import initialState from './initialState';
import {SBL_LOGIN_RESPONSE} from "../actions/actionTypes";

export default function sblLoginReducer(state = initialState.sbl_login_response, action) {
    switch (action.type) {
        case types.SBL_LOGIN_RESPONSE:
            console.log('sblLoginReducer SBL_LOGIN_RESPONSE called.' + JSON.stringify(action));
            //return Object.assign({}, state, {something: "do something."});
            return Object.assign({}, state, action);
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/sblLoginReducer.js